
$(function() {

    google.maps.event.addDomListener(window, 'load', function () {
        var places = new google.maps.places.Autocomplete(
            /** @type {!HTMLInputElement} */ (
                $('input.geoCity')[0]), {
                types: ['(regions)'],
                componentRestrictions: {country: ['fr','be','ch','lu']},
            });
        google.maps.event.addListener(places, 'place_changed', function () {
            var place = places.getPlace();
            console.log(place);

            $('#geoLat').val(place.geometry.location.lat());
            $('#geoLng').val(place.geometry.location.lng());

            // console.log(place.address_components);
            for(var i= 0; i < place.address_components.length; i++) {
                if(place.address_components[i].types.indexOf('locality') !== -1) {
                    $('#geoLocality').val(place.address_components[i].long_name);
                }
                if(place.address_components[i].types.indexOf('country') !== -1) {
                    $('#geoCountry').val(place.address_components[i].short_name);
                }
                if(place.address_components[i].types.indexOf('postal_code') !== -1) {
                    $('#geoCodePostal').val(place.address_components[i].short_name);
                }
            }
            $('#geoResult').html('').hide();
            // $('.geoCity').val(value);
            $('.geoCity').parent('.inputIcon').addClass('active');
            $('.geoCity').closest('.form-group').removeClass('has-error');
            $('.geoCity').closest('.form-group').find('.help-block').remove();
            $(".geoCity").attr("readonly", true);
        });
    });

    //
    // // $(".geoCity").geocomplete({
    // //     details: ".filtresCov",
    // //     detailsAttribute: "data-geo",
    // //     componentRestrictions: {country: ["fr"]},
    // //     types: ["(cities)"]
    // // }).bind("geocode:result", function(event, result){
    // //
    // //     // $('#fLocationSelect').removeClass('hidden');
    // //     // $('.fAddressSpan').html($('#fAddress').val());
    // // });
    // var autocomplete;
    // var inputData = $("#geoCity");
    // console.log(inputData);
    //
    //
    // autocomplete = new google.maps.places.Autocomplete(
    //     /** @type {!HTMLInputElement} */ (
    //         document.getElementById('geoCity')), {
    //         types: ['(cities)'],
    //         componentRestrictions: {country: ['fr','be','ch']},
    //     });
    // places = new google.maps.places.PlacesService();
    //
    // autocomplete.addListener('place_changed', onPlaceChanged);
    //
    // function onPlaceChanged() {
    //     var place = autocomplete.getPlace();
    //     if (place.geometry) {
    //         map.panTo(place.geometry.location);
    //         map.setZoom(15);
    //         search();
    //     } else {
    //         document.getElementById('geoCity').placeholder = 'Enter a city';
    //     }
    // }
    // function initMultipleRestrictions() {
    //
    //     // $(".geoCity").on("keyup", function (evt) {
    //     //     evt.preventDefault();
    //     //     evt.stopImmediatePropagation();
    //     //     var inputData = $(".geoCity").val();
    //     //     // alert(this.value + ' - '+ inputData);
    //     //     // if (this.value == $(this).data('curr_val'))
    //     //     //     return false;
    //     //     $('#geoResult').html('');
    //     //
    //     // });
    //     //
    //     // $(".geoCity").on("keyup", function (evt) {
    //     //     evt.preventDefault();
    //     //     evt.stopImmediatePropagation();
    //     //     var inputData = $(".geoCity").val();
    //     //     // alert(this.value + ' - '+ inputData);
    //     //     // if (this.value == $(this).data('curr_val'))
    //     //     //     return false;
    //     //     $('#geoResult').html('');
    //     //     if(inputData.length > 2) {
    //     //         service = new google.maps.places.AutocompleteService();
    //     //         var requestfr = {
    //     //             input: inputData,
    //     //             types: ['geocode'],
    //     //             componentRestrictions: {country: 'fr'},
    //     //         };
    //     //         service.getPlacePredictions(requestfr, callback);
    //     //         var pays = ['be', 'de', 'it', 'lu', 'nl', 'es', 'ch'];
    //     //         for(var i= 0; i < pays.length; i++) {
    //     //             var request = {
    //     //                 input: inputData,
    //     //                 types: ['(cities)'],
    //     //                 componentRestrictions: {country: pays[i]},
    //     //             };
    //     //             service.getPlacePredictions(request, callback);
    //     //         }
    //     //     }
    //     //     if($('#geoResult').html() == '') $('#geoResult').hide();
    //     //     else $('#geoResult').show();
    //     // });
    //
    //     function callback(predictions, status) {
    //         var resultData = '';
    //         console.log('******************');
    //         console.log(predictions);
    //         console.log(status);
    //         var cpt = 0;
    //         var pays = '';
    //         if(predictions !== null) {
    //             for(var i= 0; i < predictions.length; i++) {
    //                 if(predictions[i] !== null) {
    //                     if(Array.isArray(predictions[i].types)) {
    //                         var add = false;
    //                         if(predictions[i].types.indexOf('locality') !== -1 || predictions[i].types.indexOf('postal_code') !== -1 || predictions[i].types.indexOf('sublocality') !== -1) {
    //                             var newItem = '<div class="geoItem" data-placeid="' + predictions[i].place_id + '">' + predictions[i].description + '</div>';
    //                             if(resultData.indexOf(newItem) === -1) {
    //                                 pays = predictions[i].structured_formatting.secondary_text;
    //                                 resultData += newItem;
    //                                 cpt += 1;
    //                             }
    //                         }
    //                     }
    //                 }
    //                 if(cpt > 4 && pays == 'France') break;
    //                 if(cpt > 2 && pays != 'France') break;
    //             }
    //         }
    //         if($('#geoResult').html() != undefined){
    //             if($('#geoResult').html().indexOf(resultData) === -1) {
    //                 if(pays == 'France') resultData = resultData + $('#geoResult').html();
    //                 else resultData = $('#geoResult').html() + resultData;
    //             }
    //         }
    //         if(resultData != undefined && resultData != ''){
    //             $('#geoResult').html(resultData);
    //         }
    //         if($('#geoResult').html() == '') $('#geoResult').hide();
    //         else $('#geoResult').show();
    //
    //         $('.geoItem').click(function(e) {
    //             var value = $(this).html();
    //             placesService.getDetails(
    //                 {placeId: $(this).data('placeid')},
    //                 function(results, status) {
    //                     $('#geoLat').val(results.geometry.location.lat());
    //                     $('#geoLng').val(results.geometry.location.lng());
    //
    //                     console.log(results.address_components);
    //                     for(var i= 0; i < results.address_components.length; i++) {
    //                         if(results.address_components[i].types.indexOf('locality') !== -1) {
    //                             $('#geoLocality').val(results.address_components[i].long_name);
    //                         }
    //                         if(results.address_components[i].types.indexOf('country') !== -1) {
    //                             $('#geoCountry').val(results.address_components[i].short_name);
    //                         }
    //                         if(results.address_components[i].types.indexOf('postal_code') !== -1) {
    //                             $('#geoCodePostal').val(results.address_components[i].short_name);
    //                         }
    //                     }
    //                     $('#geoResult').html('').hide();
    //                     $('.geoCity').val(value);
    //                     $('.geoCity').parent('.inputIcon').addClass('active');
    //                     $('.geoCity').closest('.form-group').removeClass('has-error');
    //                     $('.geoCity').closest('.form-group').find('.help-block').remove();
    //                     $(".geoCity").attr("readonly", true);
    //                 }
    //             );
    //             e.preventDefault();
    //             e.stopPropagation();
    //         });
    //     }
    // }
    $('.inputIcon .icon-bold-close').click(function(e) {
        $('#geoLat').val('');
        $('#geoLng').val('');
        $('#geoLocality').val('');
        $('#geoCountry').val('');
        $('#geoCodePostal').val('');
        $('#geoType').val('');
        $('.geoCity').val('').removeClass('active');
        $('.geoCity').parent('.inputIcon').removeClass('active');
        $(".geoCity").attr("readonly", false);
        $(".geoCity").focus();
        e.preventDefault();
        e.stopPropagation();
    });
    // var placesService = new google.maps.places.PlacesService(document.createElement('div'));

    //
    // google.maps.event.addDomListener(window, 'load', initMultipleRestrictions);
    // $( document ).ready(function() {
    //     initMultipleRestrictions();
    // });


    // $("#start").geocomplete({
    //     details: "form"
    // });
    $('#fMois, #fDept, #fRegion, #fPays').change(function(e) {
        e.preventDefault();
        if($(this).val() == 'all') $(this).removeClass('active');
        else $(this).addClass('active');

        if($(this).attr('id') == 'fDept') {
            $('#fPays').val('all').removeClass('active');
            $('#fRegion').val('all').removeClass('active');
        }
        if($(this).attr('id') == 'fPays') {
            $('#fDept').val('all').removeClass('active');
            $('#fRegion').val('all').removeClass('active');
        }
        if($(this).attr('id') == 'fRegion') {
            $('#fDept').val('all').removeClass('active');
            $('#fPays').val('all').removeClass('active');
        }
    });
    // $('#fMois, #fDept, #fRegion, #fPays, #fCriteres .field').change(function(e) {
    //     e.preventDefault();
    //     filterFestivals($(this).attr('id'));
    // });
    //
    // $('#filtresGeoCancel').click(function() {
    //     $('#filtresGeo').hide();
    //     $('#filtresGeoEdit').hide();
    //     $('#filtresNoGeo').show();
    // });
    //
    // $('#fGeoLoc').click(function(e) {
    //     e.preventDefault();
    //     if(navigator.geolocation)
    //         navigator.geolocation.getCurrentPosition(maPosition);
    // });
});


var buildUrl = function(base, key, value) {
    var sep = (base.indexOf('?') > -1) ? '&' : '?';
    return base + sep + key + '=' + value;
}

// function filterFestivals(id, scroll) {
//     var scroll = typeof scroll !== 'undefined' ? scroll : true;
//
//     var filterUrl = '/festivals/filter.json';
//     var fIdPaysVal = '';
//     var fDeptVal = $('#fDept').val();
//     var fRegionVal = $('#fRegion').val();
//     if(id == 'fMois') {
//         $('#fMois').parent('.select-mois').addClass('active');
//     }
//     if(id == 'fRegion') {
//         fDeptVal = '';
//         fIdPaysVal = '';
//         $('#fLat').val('');
//         $('#fLng').val('');
//         $('#fDept').val('all');
//         $('#fPays').val('all');
//         $('#fRegion').parent('.select-mois').addClass('active');
//         $('#fDept').parent('.select-mois').removeClass('active');
//         $('#fPays').parent('.select-mois').removeClass('active');
//     }
//     if(id == 'fDept') {
//         fRegionVal = '';
//         fIdPaysVal = '';
//         $('#fLat').val('');
//         $('#fLng').val('');
//         $('#fPays').val('all');
//         $('#fRegion').val('all');
//         $('#fRegion').parent('.select-mois').removeClass('active');
//         $('#fDept').parent('.select-mois').addClass('active');
//         $('#fPays').parent('.select-mois').removeClass('active');
//     }
//     if(id == 'fPays') {
//         fIdPaysVal = $('#fPays').val();
//         fRegionVal = '';
//         fDeptVal = '';
//         $('#fLat').val('');
//         $('#fLng').val('');
//         $('#fDept').val('all');
//         $('#fRegion').val('all');
//         $('#fRegion').parent('.select-mois').removeClass('active');
//         $('#fDept').parent('.select-mois').removeClass('active');
//         $('#fPays').parent('.select-mois').addClass('active');
//     }
//     if(id == 'fAPays') {
//         fIdPaysVal = $('#fIdPays').val();
//         fRegionVal = '';
//         fDeptVal = '';
//         $('#fLat').val('');
//         $('#fLng').val('');
//         $('#fDept').val('all');
//         $('#fPays').val(fIdPaysVal);
//         $('#fRegion').val('all');
//         $('#fRegion').parent('.select-mois').removeClass('active');
//         $('#fDept').parent('.select-mois').removeClass('active');
//         $('#fPays').parent('.select-mois').addClass('active');
//     }
//     var fIds = ['fDept', 'fPays', 'fRegion', 'fMois'];
//     for(var i in fIds) {
//         var el = $('#'+fIds[i]);
//         if(el.val() == 'all') el.removeClass('active');
//         else el.addClass('active');
//     }
//
//     var data = {
//         fLat: $('#fLat').val(),
//         fLng: $('#fLng').val(),
//         fMois: $('#fMois').val(),
//         fIdPays: fIdPaysVal,
//         fDept: fDeptVal,
//         fRegion: fRegionVal,
//         fIsGratuit: ($('#fIsGratuit').is(':checked')) ? 1 : 0,
//         fIsCamping: ($('#fIsCamping').is(':checked')) ? 1 : 0
//     };
//
//     var urlNotAjax = '/festivals?' + decodeURIComponent( $.param( data ) );
//
//     if($('#fNotAjax').val() == 1) {
//
//         setTimeout(function(){
//             $('.circle').addClass('active');
//             document.location.href = urlNotAjax;
//             return false;
//         }, 200);
//     }else {
//         $.ajax({
//             url : filterUrl,
//             type : 'GET',
//             data : data,
//             dataType : 'json',
//             success : function(code, statut){
//                 setTimeout(function(){
//                     if(code.ville || code.pays) {
//                         $('#filtresNoGeo').hide();
//                         $('#filtresGeo').show();
//                         $('#filtresGeoEdit').show();
//                     }
//                     if(code.ville) {
//                         $('#fLabelLieu').html("près de");
//                         $('#fNameLieu').html(code.ville);
//                     }else if(code.pays) {
//                         $('#fLabelLieu').html("en");
//                         $('#fNameLieu').html(code.pays);
//                     }else {
//                         $('#filtresGeo').hide();
//                         $('#filtresGeoEdit').hide();
//                         $('#filtresNoGeo').show();
//                     }
//                     if(code.urlMore) {
//                         $('#fUrlMore').attr('href', code.urlMore);
//                         $('#fUrlMore').html(code.urlMoreText);
//                     }
//
//                     $('.results').html(code.html);
//
//                     $('.circle').removeClass('active');
//
//                     $('.mapselector').hide();
//
//                     $('.results').fadeIn();
//
//                     if(scroll) $(window).scrollTo( $('.results').offset().top, 800, {easing:'easeOutQuad'} );
//                 }, 600);
//
//             },
//
//             error : function(resultat, statut, erreur){
//                 console.log('error');
//                 console.log(resultat);
//                 console.log(statut);
//                 console.log(erreur);
//             },
//             beforeSend : function(statut, erreur){
//                 setTimeout(function(){
//                     $('.circle').addClass('active');
//                 }, 100);
//             }
//         });
//     }
// }


// function maPosition(position) {
//     var infopos = "Position déterminée :\n";
//     infopos += "Latitude : "+position.coords.latitude +"\n";
//     infopos += "Longitude: "+position.coords.longitude+"\n";
//     infopos += "Altitude : "+position.coords.altitude +"\n";
//     console.log(position);
//     $('#fLat').val(position.coords.latitude);
//     $('#fLng').val(position.coords.longitude);
//     filterFestivals(false, false);
//     // $.get(
//     //     "/geo-save",
//     //     {
//     //         lat: position.coords.latitude,
//     //         lng: position.coords.longitude
//     //     }
//     // );
// }